"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const _FloatingContent_1 = require("../_FloatingContent");
const DropDownDivider_1 = __importDefault(require("./DropDownDivider"));
const DropDownButton_1 = __importDefault(require("./DropDownButton"));
const DropDownLink_1 = __importDefault(require("./DropDownLink"));
// styles
require("./dropDown.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    className: undefined,
    id: undefined,
    style: undefined,
    "data-testid": "tecma-DropDown",
    arrow: false,
    position: "bottom-center",
};
const DropDown = (_a) => {
    var { className, trigger, children, isOpen, arrow, position, onToggle, parentElement } = _a, rest = __rest(_a, ["className", "trigger", "children", "isOpen", "arrow", "position", "onToggle", "parentElement"]);
    const classList = (0, classnames_1.default)("tecma-dropDown", { arrow, [`${position}`]: position }, className);
    return ((0, jsx_runtime_1.jsx)(_FloatingContent_1.FloatingContent, Object.assign({ trigger: trigger, isShown: isOpen, position: position, onToggle: onToggle, parentElement: parentElement }, { children: (0, jsx_runtime_1.jsx)("div", Object.assign({ className: classList }, rest, { children: (0, jsx_runtime_1.jsx)("ul", { children: children }) })) })));
};
DropDown.defaultProps = defaultProps;
const DropDownSpace = Object.assign(DropDown, {
    Element: DropDownButton_1.default,
    Divider: DropDownDivider_1.default,
    Link: DropDownLink_1.default,
});
exports.DropDown = DropDownSpace;
